import { render } from "./OptionsBag.vue?vue&type=template&id=1bc37b8e"
import script from "./OptionsBag.vue?vue&type=script&lang=js"
export * from "./OptionsBag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__